var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 60,
    viewBox: "0 0 56 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.6006,
    cy: 24,
    r: 24,
    fill: "url(#paint0_linear_6204_151004)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6204_151004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9941 38.3906C19.2638 38.3905 12.9999 32.1296 13 24.4023C13.0002 16.6679 19.2634 10.4006 26.9941 10.4004C34.7203 10.4004 40.9891 16.6678 40.9893 24.4023C40.9893 32.1297 34.7205 38.3906 26.9941 38.3906ZM26.9941 28.4766C27.7928 28.4764 28.4404 27.7684 28.4404 26.8955V18.04C28.4402 17.1673 27.7926 16.4601 26.9941 16.46C26.1956 16.46 25.5481 17.1672 25.5479 18.04V26.8955C25.5479 27.7685 26.1954 28.4766 26.9941 28.4766ZM26.9951 32.8574C27.7942 32.8574 28.4408 32.2102 28.4404 31.4111C28.4404 30.6125 27.7943 29.9649 26.9951 29.9648C26.1964 29.9648 25.5488 30.6124 25.5488 31.4111C25.5489 32.2097 26.1965 32.8574 26.9951 32.8574Z",
    fill: "url(#paint1_linear_6204_151004)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6204_151004",
    x: 0,
    y: 3.40039,
    width: 55.9893,
    height: 55.9902,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6204_151004"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6204_151004",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6204_151004",
    x1: 29.6896,
    y1: 50.7687,
    x2: 54.8771,
    y2: 20.9906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE3E67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.263492,
    stopColor: "#FE4B57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528858,
    stopColor: "#FE5A47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765545,
    stopColor: "#FF4F54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE633D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6204_151004",
    x1: 33.9854,
    y1: 39.8923,
    x2: 45.007,
    y2: 16.5403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.8f6bb0e7d51aae8a5746277398bc0408.svg";
export { ForwardRef as ReactComponent };